var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { InputWrapper, Label, RequiredLabel, ErrorMessage } from "../../components/Inputs/Inputs.styled";
import { Grid, Typography, Icon, Inputs, Button } from "../../components";
import { List, ListItem, TickCircleIconWrapper, ListItemText } from "../../prf/InsuranceScope/InsuranceScope.styled";
import { district } from "./consts";
import { FormTeser, FormWrapper, Or, PhoneLinke, SelectWrapper } from "./ContactForm.styled";
var ValidationSchema = Yup.object().shape({
  name: Yup.string().min(2, "Za mała ilość znaków, min. 3.").max(50, "Za duża ilość znaków, max. 50.").required("Pole wymagane"),
  phone: Yup.string().min(9, "Za mała ilość znaków, min. 9.").max(12, "Za duża ilość znaków, max. 12.").required("Pole wymagane"),
  district: Yup.number().nullable().required("Pole wymagane"),
  email: Yup.string().email("Niepoprawny adres e-mail"),
  termsA: Yup.bool().oneOf([true], "Pole wymagane"),
  termsB: Yup.bool().oneOf([true], "Pole wymagane"),
  termsC: Yup.bool().oneOf([true], "Pole wymagane"),
  termsD: Yup.bool().oneOf([true], "Pole wymagane"),
  termsE: Yup.bool().oneOf([true], "Pole wymagane")
});

var ContactForm = function ContactForm(_a) {
  var _b = _a.title,
      title = _b === void 0 ? "Nie znalazłeś oferty dla siebie?" : _b,
      _c = _a.subtitle,
      subtitle = _c === void 0 ? "Chcesz dowiedzieć się więcej o warunkach finansowania lub nasza propozycja nie spełniła Twoich oczekiwań? Zachęcamy do kontaktu z Agro Ekspertami." : _c,
      _d = _a.provideList,
      provideList = _d === void 0 ? ["Pomożemy dopełnić formalności", "Dobierzemy odpowiednie warunki finansowania"] : _d,
      _e = _a.textBtn,
      textBtn = _e === void 0 ? "Zamów rozmowę z Agro Ekspertem" : _e,
      isExtended = _a.isExtended,
      anchor = _a.anchor,
      _f = _a.onSubmit,
      _onSubmit = _f === void 0 ? function () {
    return null;
  } : _f,
      props = __rest(_a, ["title", "subtitle", "provideList", "textBtn", "isExtended", "anchor", "onSubmit"]);

  var formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      district: null,
      email: "",
      termsA: false,
      termsB: false,
      termsC: false,
      termsD: false,
      termsE: false
    },
    validationSchema: ValidationSchema,
    onSubmit: function onSubmit(values, formikHelpers) {
      _onSubmit(values, formikHelpers);
    }
  });

  var getValue = function getValue(value) {
    var selectedDiscrict = district.find(function (d) {
      return d.id === Number(value);
    });

    if (selectedDiscrict) {
      return {
        label: selectedDiscrict.name,
        value: selectedDiscrict.id
      };
    }

    return null;
  };

  return React.createElement(Grid.Container, __assign({
    id: anchor,
    fluid: true,
    overflowX: "hidden"
  }, props), React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, React.createElement(Grid.Container, null, React.createElement(Grid.Row, null, React.createElement(FormTeser, {
    xs: 12,
    lg: 5
  }, React.createElement(Grid.Box, {
    px: 4,
    py: 5
  }, React.createElement(Typography, {
    variant: "h1",
    color: "white",
    fontSize: "2.5rem",
    isUpperCase: true,
    mb: 4,
    pr: [1, 2, 2, 6]
  }, title), React.createElement(Typography, {
    color: "white",
    mb: 4
  }, subtitle), React.createElement(List, {
    bg: "green"
  }, provideList.map(function (text, idx) {
    return React.createElement(ListItem, {
      key: "provide_" + idx
    }, React.createElement(TickCircleIconWrapper, null, React.createElement(Icon, {
      name: "TickCircle",
      width: 24,
      height: 24
    })), React.createElement(ListItemText, {
      bg: "green"
    }, text));
  })))), React.createElement(FormWrapper, {
    xs: 12,
    lg: 7
  }, React.createElement(Grid.Box, {
    px: 4,
    py: 5
  }, React.createElement(Grid.Row, {
    mb: [2, 2, 2, 4]
  }, React.createElement(Grid.Col, {
    xs: 12,
    md: 6
  }, React.createElement(Inputs.TextField, {
    label: "Twoj\u0119 imi\u0119",
    isRequired: true,
    placeholder: "Wpisz swoje Imi\u0119",
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("name", target.value);
    },
    value: formik.values.name,
    errorMessage: formik.errors.name
  })), React.createElement(Grid.Col, {
    xs: 12,
    md: 6
  }, React.createElement(Inputs.TextField, {
    label: "Numer telefonu",
    isRequired: true,
    placeholder: "Wpisz sw\xF3j nr telefonu",
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("phone", target.value);
    },
    value: formik.values.phone,
    errorMessage: formik.errors.phone
  }))), React.createElement(Grid.Row, {
    mb: [2, 2, 2, 4]
  }, React.createElement(Grid.Col, {
    xs: 12,
    md: 6
  }, React.createElement(Inputs.TextField, {
    label: "Adres e-mail",
    placeholder: "Podaj adres e-mail",
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("email", target.value);
    },
    value: formik.values.email,
    errorMessage: formik.errors.email
  })), React.createElement(Grid.Col, {
    xs: 12,
    md: 6
  }, React.createElement(SelectWrapper, {
    error: !!formik.errors.district
  }, React.createElement(InputWrapper, null, React.createElement(Label, {
    mb: 1
  }, "Powiat", React.createElement(RequiredLabel, {
    as: "span"
  }, "(pole obowi\u0105zkowe)"))), React.createElement(Select, {
    className: "district",
    classNamePrefix: "district-select",
    isSearchable: true,
    placeholder: "Wybierz powiat",
    noOptionsMessage: function noOptionsMessage() {
      return "Brak";
    },
    name: "district",
    options: district.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).map(function (_a) {
      var id = _a.id,
          name = _a.name;
      return {
        label: name,
        value: id
      };
    }),
    value: getValue(formik.values.district),
    onChange: function onChange(option) {
      if (option) {
        formik.setFieldValue("district", option.value);
      }
    }
  }), !!formik.errors.district && React.createElement(ErrorMessage, null, formik.errors.district)))), React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    xs: 12,
    mb: 3
  }, React.createElement(Inputs.CheckBox, {
    checked: formik.values.termsA,
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("termsA", target.checked);
    },
    errorMessage: formik.errors.termsA,
    sneakPeak: "Wyra\u017Cam zgod\u0119 na przetwarzanie przez sp\xF3\u0142k\u0119 BNP Paribas Bank Polska S.A. z siedzib\u0105 w Warszawie, ul. Kasprzaka 2, kod pocztowy: 01-211 Warszawa, zarejestrowan\u0105 w rejestrze",
    text: "Wyra\u017Cam zgod\u0119 na przetwarzanie przez sp\xF3\u0142k\u0119 BNP Paribas Bank Polska S.A. z siedzib\u0105 w Warszawie, ul. Kasprzaka 2, kod pocztowy: 01-211 Warszawa, zarejestrowan\u0105 w rejestrze przedsi\u0119biorc\xF3w Krajowego Rejestru S\u0105dowego przez S\u0105d Rejonowy dla m. st. Warszawy w Warszawie, XIII Wydzia\u0142 Gospodarczy Krajowego Rejestru S\u0105dowego pod nr KRS 0000011571, posiadaj\u0105cy NIP 526-10-08-546 oraz kapita\u0142 zak\u0142adowy w wysoko\u015Bci 147 418 918 z\u0142 w ca\u0142o\u015Bci wp\u0142acony (\u201EBank\u201D), moich danych osobowych wskazanych w Formularzu kontaktowym, w celu marketingu produkt\xF3w i us\u0142ug w\u0142asnych Banku."
  })), React.createElement(Grid.Col, {
    xs: 12,
    mb: 3
  }, React.createElement(Inputs.CheckBox, {
    checked: formik.values.termsB,
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("termsB", target.checked);
    },
    errorMessage: formik.errors.termsB,
    sneakPeak: "Wyra\u017Cam zgod\u0119, zgodnie z ustaw\u0105 z dnia 18 lipca 2002 r. o \u015Bwiadczeniu us\u0142ug drog\u0105 elektroniczn\u0105 na otrzymywanie od Banku drog\u0105 elektroniczn\u0105 informacji stanowi\u0105cych ",
    text: "Wyra\u017Cam zgod\u0119, zgodnie z ustaw\u0105 z dnia 18 lipca 2002 r. o \u015Bwiadczeniu us\u0142ug drog\u0105 elektroniczn\u0105 na otrzymywanie od Banku drog\u0105 elektroniczn\u0105 informacji stanowi\u0105cych informacje handlowe w rozumieniu ww. ustawy, w tym wiadomo\u015Bci e-mail."
  })), React.createElement(Grid.Col, {
    xs: 12,
    mb: 3
  }, React.createElement(Inputs.CheckBox, {
    checked: formik.values.termsC,
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("termsC", target.checked);
    },
    errorMessage: formik.errors.termsC,
    sneakPeak: "Wyra\u017Cam zgod\u0119, zgodnie z ustaw\u0105 z dnia 16 lipca 2004 r. Prawo telekomunikacyjne na przedstawianie przez Bank drog\u0105 telefoniczn\u0105 informacji dotycz\u0105cych",
    text: "Wyra\u017Cam zgod\u0119, zgodnie z ustaw\u0105 z dnia 16 lipca 2004 r. Prawo telekomunikacyjne na przedstawianie przez Bank drog\u0105 telefoniczn\u0105 informacji dotycz\u0105cych ofert lub promocji produkt\xF3w i us\u0142ug oferowanych przez Bank."
  })), React.createElement(Grid.Col, {
    xs: 12,
    mb: 3
  }, React.createElement(Inputs.CheckBox, {
    checked: formik.values.termsD,
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("termsD", target.checked);
    },
    errorMessage: formik.errors.termsD,
    sneakPeak: "Przyjmuj\u0119 do wiadomo\u015Bci, \u017Ce administratorem danych osobowych jest BNP Paribas Bank Polska S.A., a podmiotem przetwarzaj\u0105cym dane osobowe jest Kerris Group Sp. z o.o. z siedzib\u0105 w Warszawie (00-867) przy al. Jana Paw\u0142a II 27",
    text: React.createElement(React.Fragment, null, "Przyjmuj\u0119 do wiadomo\u015Bci, \u017Ce administratorem danych osobowych jest BNP Paribas Bank Polska S.A., a podmiotem przetwarzaj\u0105cym dane osobowe jest Kerris Group Sp. z o.o. z siedzib\u0105 w Warszawie (00-867) przy al. Jana Paw\u0142a II 27, zarejestrowany w rejestrze przedsi\u0119biorc\xF3w Krajowego Rejestru S\u0105dowego przez S\u0105d Rejonowy dla m. st. Warszawy, XII Wydzia\u0142 Gospodarczy Krajowego Rejestru S\u0105dowego pod nr KRS 0000412151. Dane s\u0105 przetwarzane przez Bank w celu marketingu i promocji produkt\xF3w i us\u0142ug oferowanych przez Bank (art. 6 ust. 1 lit. f RODO). Przys\u0142uguje mi prawo dost\u0119pu do danych, \u017C\u0105dania ich sprostowania, \u017C\u0105dania usuni\u0119cia, \u017C\u0105dania ograniczenia przetwarzania lub prawo przenoszenia danych prawo sprzeciwu, prawo wniesienia skargi do organu nadzorczego, a tak\u017Ce prawo do cofni\u0119cia zgody na przetwarzanie danych. Cofni\u0119cie zgody nie ma wp\u0142ywu na zgodno\u015B\u0107 z prawem przetwarzania, kt\xF3rego dokonano na podstawie zgody przed jej cofni\u0119ciem. Szczeg\xF3\u0142owe zasady przetwarzania danych osobowych przez Bank zawarte s\u0105 na stronie:", " ", React.createElement("a", {
      href: "https://www.bnpparibas.pl/repozytorium/rodo",
      target: "_blank",
      rel: "noreferrer"
    }, "https://www.bnpparibas.pl/repozytorium/rodo"))
  })), React.createElement(Grid.Col, {
    xs: 12,
    mb: 3
  }, React.createElement(Inputs.CheckBox, {
    checked: formik.values.termsE,
    onChange: function onChange(_a) {
      var target = _a.target;
      return formik.setFieldValue("termsE", target.checked);
    },
    errorMessage: formik.errors.termsE,
    text: React.createElement(React.Fragment, null, "Akceptuj\u0119", " ", React.createElement("a", {
      href: "/static/pdf/regulamin.pdf",
      target: "_blank"
    }, "regulamin"), " ", "portalu Agronomist.pl")
  }))), React.createElement(Grid.Box, {
    mt: 4,
    display: "flex",
    justifyContent: "center"
  }, !formik.isSubmitting && !formik.status && React.createElement(Button, {
    onClick: formik.submitForm
  }, textBtn), formik.isSubmitting && !formik.status && React.createElement(Typography, {
    variant: "small"
  }, "Wysy\u0142anie..."), !formik.isSubmitting && !!formik.status && React.createElement(Typography, {
    variant: "small"
  }, "Formularz zosta\u0142 poprawnie z\u0142o\u017Cony. Dzi\u0119kujemy.")), isExtended && React.createElement(React.Fragment, null, React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    xs: 12
  }, React.createElement(Or, null, "lub"))), React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    xs: 12,
    md: 6,
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, React.createElement(Icon, {
    name: "Phone",
    width: "4.625rem",
    color: "brandGreen"
  }), React.createElement(Typography, {
    variant: "small"
  }, "Zadzwo\u0144 do nas"), React.createElement(PhoneLinke, {
    href: "tel:+48500970345"
  }, "+48 500 970 345")), React.createElement(Grid.Col, {
    xs: 12,
    md: 6,
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, React.createElement(Icon, {
    color: "brandGreen",
    name: "SimpleHouse",
    width: "4.625rem"
  }), React.createElement(Typography, {
    variant: "small"
  }, "Przyjd\u017A do oddzia\u0142u"), React.createElement(Button, {
    onClick: function onClick() {
      window.open("https://www.bnpparibas.pl/kontakt/oddzialy-z-obsluga-detaliczna-i-biznesowa?type=department_retail_business", "_blank").focus();
    },
    isPrimary: true
  }, "znajd\u017A"))))))))));
};

export default ContactForm;